<script>
export let name = 'huge-heart';
export let color = 'text-current';
export let size = 'xsmall';
export let klass = '';
</script>

<i class="huge-icon {[name, `is-${size}`, color, klass].join(' ')}" />